export var orderOptions = [{
  id: '-revision/created',
  label: 'Más recientes'
}, {
  id: '-socialStats/likes',
  label: 'Más útiles'
}, {
  id: '-score',
  label: 'Más valoradas'
}];